/**
 * Featurevisor datafile selection and shared feature keys for Academy.
 *
 * Keys must match `flags/features/*.yml` in the Qwixl workspace.
 */

export function featureFlagsDatafileEnv(): 'staging' | 'production' {
  if (!import.meta.env.PROD) return 'staging'

  const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : ''
  if (hostname === 'stg.academy.qwixl.com' || hostname.includes('omnis-stg')) {
    return 'staging'
  }

  if (import.meta.env.VERCEL_ENV === 'preview') return 'staging'

  return 'production'
}

export const FEATURE_KEYS = {
  tutorResponseStreaming: 'tutor-response-streaming',
  tutorVoiceOutput: 'tutor-voice-output',
  tutorVoiceInput: 'tutor-voice-input',
  tutorUnifiedPlatformUi: 'tutor-unified-platform-ui',
  tutorPlayground: 'tutor-playground',
  resourceLibrary: 'resource-library',
  notebookV1: 'notebook-v1',
} as const
